var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editor-build-options-view" }, [
    _c(
      "div",
      { staticClass: "editor-build-options-view-header" },
      [
        _c("div", { staticClass: "editor-build-options-view-header-title" }, [
          _vm._v(_vm._s(_vm.$t("views.editorBuildOptions.title"))),
        ]),
        _c("IconComponent", { on: { click: _vm.onCloseClick } }, [
          _vm._v("close"),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "editor-build-options-view-body" }, [
      _c("div", { staticClass: "editor-build-options-view-body-header" }, [
        _vm._v(_vm._s(_vm.$t("views.editorBuildOptions.howToFill"))),
      ]),
      _c(
        "div",
        { staticClass: "editor-build-options-view-options-container" },
        [
          _c(
            "div",
            {
              staticClass: "editor-build-options-view-option",
              class: {
                "editor-build-options-view-option-selected":
                  _vm.internalValue === false,
              },
              on: {
                click: function ($event) {
                  return _vm.onAutoFillClick(false)
                },
              },
            },
            [
              _c("img", {
                staticClass: "editor-build-options-view-option-image",
                attrs: { src: _vm.getImage("fillyourself") },
              }),
              _c(
                "span",
                { staticClass: "editor-build-options-view-option-type" },
                [
                  _vm._v(
                    _vm._s(_vm.$t("views.editorBuildOptions.fillYoursSelf"))
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "editor-build-options-view-option",
              class: {
                "editor-build-options-view-option-selected": _vm.internalValue,
              },
              on: {
                click: function ($event) {
                  return _vm.onAutoFillClick(true)
                },
              },
            },
            [
              _c("img", {
                staticClass: "editor-build-options-view-option-image",
                attrs: { src: _vm.getImage("autofill") },
              }),
              _c(
                "span",
                { staticClass: "editor-build-options-view-option-type" },
                [_vm._v(_vm._s(_vm.$t("views.editorBuildOptions.autoFill")))]
              ),
            ]
          ),
        ]
      ),
    ]),
    _c(
      "div",
      { staticClass: "editor-build-options-view-footer" },
      [
        !_vm.isMobile
          ? _c("divider", { staticClass: "divider horizontal full" })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "editor-build-options-view-footer-buttons" },
          [
            _c(
              "ButtonComponent",
              {
                attrs: { color: "secondary", width: "100%" },
                on: { click: _vm.onCloseClick },
              },
              [_vm._v(_vm._s(_vm.$t("views.editorBuildOptions.notNow")))]
            ),
            _c(
              "ButtonComponent",
              {
                attrs: { disabled: _vm.internalValue === null, width: "100%" },
                on: { click: _vm.onApplyClick },
              },
              [_vm._v(_vm._s(_vm.$t("views.editorBuildOptions.apply")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }